/**
 * @generated SignedSource<<9537859a5d243e08472087d97d4fd516>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReopenedEvent$data = {
  readonly actor: {
    readonly " $fragmentSpreads": FragmentRefs<"EventActor" | "EventActorAvatarItemBadge">;
  } | null;
  readonly createdAt: string;
  readonly databaseId: number | null;
  readonly " $fragmentType": "ReopenedEvent";
};
export type ReopenedEvent$key = {
  readonly " $data"?: ReopenedEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReopenedEvent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReopenedEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventActor"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventActorAvatarItemBadge"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ReopenedEvent",
  "abstractKey": null
};

(node as any).hash = "e1fb1b601e33496892d2b4c0f1498dc5";

export default node;
